import 'babel-polyfill';
import { init } from './init';

/**
 * http://caniuse.com/#feat=addeventlistener
 */
window.addEventListener('load', init);



// WEBPACK FOOTER //
// ./app/index.ts